import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {wineRed} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  alertIcon: {
    fontSize: 16,
    fontWeight: '700',
    color: wineRed,
    marginLeft: indent,
    marginTop: indent * 0.12,
  },
});
